const CloseSmall = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.87536 5.28595C5.71264 5.12323 5.44882 5.12323 5.2861 5.28595C5.12338 5.44867 5.12338 5.71249 5.2861 5.8752L9.41089 9.99999L5.2861 14.1248C5.12338 14.2875 5.12338 14.5513 5.2861 14.714C5.44882 14.8768 5.71264 14.8768 5.87536 14.714L10.0001 10.5893L14.1249 14.714C14.2877 14.8768 14.5515 14.8768 14.7142 14.714C14.8769 14.5513 14.8769 14.2875 14.7142 14.1248L10.5894 9.99999L14.7142 5.8752C14.8769 5.71249 14.8769 5.44867 14.7142 5.28595C14.5515 5.12323 14.2877 5.12323 14.1249 5.28595L10.0001 9.41074L5.87536 5.28595Z"
        fill="#646464"
      />
    </svg>
  )
}

export default CloseSmall
